
import { CreateElement } from "vue";
import { Component, Vue } from "vue-property-decorator";
@Component
export default class UMessages extends Vue {
  public render(h: CreateElement) {
    return h(
      "div",
      { class: "u-messages" },
      this.$scopedSlots?.default && this.$scopedSlots?.default({})
    );
  }
}
